// extracted by mini-css-extract-plugin
export default {"scope":"t2ZF+","buttons":"_9U75L","select":"Tblbq"};